// extracted by mini-css-extract-plugin
export default {"ctaContainer":"Gdd4bd5","ctaContainerPaddingReset":"G0f282a","nextDelivery":"Gb6d1a2"};